// extracted by mini-css-extract-plugin
export default {"header":"_f65ff131","title":"_518adaae","subtitleCta":"_9d2645bc"};